import Vuex from 'vuex'
import todos from './modules/todos'

// Load Vuex

export default new Vuex.Store({
    modules:{
        todos,
    },
});